import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkBackendConnectivity } from '../utils/connectivity';
import { setData } from '../redux/app/Actions';
import Send from '../communication';
import { useNetworkState } from 'react-use';

export const SystemInitializer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const networkState = useNetworkState();

  const handleConnectivityChange = useCallback(async () => {
    // Verifica conectividade com o backend
    const isConnected = await checkBackendConnectivity();
    
    if (!isConnected) {
      console.log('Sistema offline - redirecionando...');
      dispatch(setData({ online: false }));
      Send.setOnline(false);
      navigate('/offline');
    } else {
      console.log('Sistema online');
      dispatch(setData({ online: true }));
      Send.setOnline(true);
    }
  }, [dispatch, navigate]);

  // Monitora mudanças na conectividade do navegador
  // useEffect(() => {
  //   if (networkState.online) {
  //     handleConnectivityChange();
  //   } else {
  //     dispatch(setData({ online: false }));
  //     Send.setOnline(false);
  //     navigate('/offline');
  //   }
  // }, [handleConnectivityChange, dispatch, navigate]);

  // Monitora recarregamento da página
  useEffect(() => {
    handleConnectivityChange();
  }, []);

  return null; // Componente não renderiza nada visualmente
};
